export default {
	select_all: "Selecionar Todos",
};
